module.exports = __webpack_public_path__ + "static/img/zl.08ac85f1.png";